import React from 'react';
import ChatWindow from './ChatWindow';

export default function GroupChat({ groupId, currentUser }) {
  return (
    <div>
      <h2>Group Chat</h2>
      <ChatWindow chatType="group" chatId={groupId} currentUser={currentUser} />
    </div>
  );
}
